
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#EFBC2E","d":"M23 44v8.5a2.5 2.5 0 105 0V44h-5z"}}),_c('path',{attrs:{"fill":"#EF941D","d":"M24.913 49.255L28 51.018v-4.607l-1.099-.627a7.416 7.416 0 00-2.65-.911L23 44.694v4.041l.686.098c.435.062.847.203 1.227.422z"}}),_c('path',{attrs:{"fill":"#F2DAAE","d":"M44.4 37.4l-2.084-2.083a5.463 5.463 0 01-1.554-3.164L37.64 7.959a5.687 5.687 0 00-11.28 0l-3.122 24.194a5.463 5.463 0 01-1.554 3.164L19.6 37.4a5.462 5.462 0 003.089 9.27l1.279.183c.681.097 1.34.322 1.937.665l3.385 1.933a5.46 5.46 0 005.42 0l3.385-1.933a5.427 5.427 0 011.937-.665l1.279-.183A5.462 5.462 0 0044.4 37.4z"}}),_c('path',{attrs:{"fill":"#62C4C3","d":"M39 51s-3 4.239-3 7 1.343 4 3 4 3-1.239 3-4-3-7-3-7z"}}),_c('path',{attrs:{"fill":"#E0C494","d":"M34.71 49.451l3.385-1.933a5.427 5.427 0 011.937-.665l1.279-.183A5.462 5.462 0 0044.4 37.4l-2.084-2.083a5.463 5.463 0 01-1.554-3.164L37.64 7.959A5.687 5.687 0 0032 3v47.171c.935 0 1.871-.24 2.71-.72z"}}),_c('path',{attrs:{"fill":"#42A5B2","d":"M36.609 60.626C37.157 61.553 38.019 62 39 62c1.657 0 3-1.239 3-4 0-1.234-.599-2.761-1.262-4.074-.595 3.251-2.157 5.788-4.129 6.7z"}})])
          )
        }
      }
    